import { ActionModal } from '@frontend/components/modal';
import { CommonMessage } from '@frontend/lang';
import { Schedule } from '@frontend/report/types';
import { MultiUserSelect } from '@frontend/user/select';
import { FormattedMessage } from 'react-intl';

import { useUpdateReceiversModal } from './update-receivers-modal.controller';

export interface UpdateReceiversModalProps {
    schedule: Schedule;
}

export const UpdateReceiversModal = (props: UpdateReceiversModalProps) => {
    const viewProps = useUpdateReceiversModal(props);

    return (
        <ActionModal
            title={
                <FormattedMessage
                    id='update-receivers-modal.title'
                    defaultMessage='Update receivers'
                />
            }
            confirm={{ onConfirm: viewProps.onSubmit, label: CommonMessage.BUTTONS.SUBMIT }}
            cancel={{ onCancel: viewProps.onCancel, label: CommonMessage.BUTTONS.CANCEL }}>
            <div className='flex w-full flex-col gap-4'>
                <MultiUserSelect
                    label={CommonMessage.OBJECTS.TRANSACTION.RECEIVERS}
                    value={viewProps.selectedReceivers}
                    onChange={viewProps.setSelectedReceivers}
                />
            </div>
        </ActionModal>
    );
};
